import { Dialog } from "primereact/dialog";
import { Divider } from "primereact/divider";
import { Tag } from "primereact/tag";

function ClienteDetalleModal({ visible, onHide, cliente }) {
    return (
        <Dialog
            header="Datos del Cliente"
            visible={visible}
            onHide={onHide}
            className="p-fluid product-dialog"
            modal={false}
            blockScroll={false}
            draggable
        >
            {cliente ? (
                <div className="grid p-3">
                    <div className="col-12">
                        <div className="flex align-items-center justify-content-between">
                            <div className="flex align-items-center">
                                <i className="pi pi-id-card mr-2" />
                                <h5 className="m-0">{cliente.razon_social}</h5>
                            </div>
                            <Tag value={cliente.activo ? "Activo" : "Inactivo"} severity={cliente.activo ? "success" : "danger"} />
                        </div>
                    </div>

                    <Divider />

                    <div className="col-12 md:col-6">
                        <h6 className="mb-3">Identificación</h6>
                        <div className="mb-2"><strong>RUT:</strong> <span>{cliente.rut || "—"}</span></div>
                        <div className="mb-2"><strong>Giro:</strong> <span>{cliente.giro || "—"}</span></div>
                        <div className="mb-2"><strong>Alias:</strong> <span>{cliente.alias || "—"}</span></div>
                        <div className="mb-2"><strong>Nombre Fantasía:</strong> <span>{cliente.nombre_fantasia || "—"}</span></div>
                        <div className="mb-2"><strong>Nombre:</strong> <span>{cliente.nombre || "—"}</span></div>
                    </div>

                    <div className="col-12 md:col-6">
                        <h6 className="mb-3">Contactos</h6>
                        {(cliente.contactos || []).length ? (
                            <ul className="m-0 p-0" style={{ listStyle: "none" }}>
                                {cliente.contactos.map((c) => (
                                    <li key={`c-${c.id}`} className="mb-2">
                                        <i className="pi pi-envelope mr-2" />
                                        <span>{c.tipo}: {c.nombre} · {c.correo} · {c.telefono}</span>
                                    </li>
                                ))}
                            </ul>
                        ) : <span>—</span>}
                    </div>

                    <Divider />

                    <div className="col-12 md:col-6">
                        <h6 className="mb-3">Representantes</h6>
                        {(cliente.representantes || []).length ? (
                            <ul className="m-0 p-0" style={{ listStyle: "none" }}>
                                {cliente.representantes.map((r) => (
                                    <li key={`r-${r.id}`} className="mb-2">
                                        <i className="pi pi-user mr-2" />
                                        <span>{r.nombre} · {r.rut} · {r.correo} · {r.telefono}</span>
                                    </li>
                                ))}
                            </ul>
                        ) : <span>—</span>}
                    </div>
                    <Divider />
                    <div className="col-12">
                        <h6 className="mb-3">Domicilios</h6>
                        {(cliente.domicilios || []).length ? (
                            <ul className="m-0 p-0" style={{ listStyle: "none" }}>
                                {cliente.domicilios.map((d, i) => (
                                    <li key={`d-${d.id || i}`} className="mb-2">
                                        <i className="pi pi-map-marker mr-2" />
                                        <span>{d.tipo}: {d.direccion}, {d.comuna} {d.region}</span>
                                    </li>
                                ))}
                            </ul>
                        ) : <span>—</span>}
                    </div>
                </div>
            ) : (
                <div>Sin datos de cliente</div>
            )}
        </Dialog>
    );
}

export default ClienteDetalleModal;